import type { MeVenue } from '@/modules/auth/me';

/**
 * Outcome of the `/` landing rule (ADR 0015): either enter a specific Venue workspace or
 * show the "choose venue" screen.
 */
export type LandingResolution = { kind: 'enter'; venueId: string } | { kind: 'choose' };

/**
 * The single landing rule, applied to every user with no role special-casing (ADR 0015):
 * last-used Venue if it is still accessible → else the only Venue when there is exactly
 * one → else the chooser. Pure so every branch is unit-testable without a router.
 */
export function resolveLanding(venues: MeVenue[], lastUsedId: string | null): LandingResolution {
  if (lastUsedId && venues.some((venue) => venue.id === lastUsedId)) {
    return { kind: 'enter', venueId: lastUsedId };
  }
  const [only] = venues;
  if (only && venues.length === 1) {
    return { kind: 'enter', venueId: only.id };
  }
  return { kind: 'choose' };
}
